// extracted by mini-css-extract-plugin
export default {"cat":"AdminPanel_cat__ekhqC"};